module.exports = __webpack_public_path__ + "stylesheets/both-landings-common_c3504c735980b363429fcf1bc623fe7a.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/landing/both-landings-common.less
// module id = vzSK
// module chunks = 153